import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { forwardRef, useCallback, useMemo } from 'react';
import { useHighlight } from '../../../contexts/field-highlighter';
export const HighlightTooltip = forwardRef(({ id, actions, as, asProps, asAs, isEditing, children, ...props }, ref) => {
    const { ref: highlightRef } = useHighlight({ tooltipButtons: actions });
    const setRefs = useCallback((node) => {
        if (typeof ref === 'function') {
            ref(node);
        }
        else {
            if (ref)
                ref.current = node;
        }
        highlightRef(node);
    }, [ref, highlightRef]);
    const Wrapper = as || Box;
    const memoedChildren = useMemo(() => {
        if (typeof children === 'function') {
            return children({ id, ref: setRefs, tabIndex: isEditing ? 1 : undefined });
        }
        return children;
    }, [setRefs, isEditing, children]);
    if (typeof children === 'function') {
        return (_jsx(Wrapper, { ...props, ...asProps, ref: setRefs, tabIndex: isEditing ? 1 : undefined, as: asAs, id: id, _focus: {
                outline: 'none'
            }, children: memoedChildren }));
    }
    return (_jsx(Wrapper, { ...props, ...asProps, ref: setRefs, as: asAs, id: id, tabIndex: isEditing ? 1 : undefined, _focus: {
            outline: 'none'
        }, children: memoedChildren }));
});
